<template>
  <v-container fluid>
    <v-row dense class="d-flex " style="height: 50px">
      <v-col md="auto">
        <v-btn
          rounded
          small
          fab
          color="primary"
          class="add-button-fab mb-2"
          @click.stop="addMenuForm()"
          :disabled="!isAdmin"
        >
        <v-icon small>mdi-plus-thick</v-icon>
        </v-btn>
        <v-btn
          v-if="sitePath.split('/').length > 2 && menus.length == 0"
          rounded
          small
          class="copy-button font-weight-bold"
          @click.stop="copyParentMenus()"
          :disabled="!isAdmin"
        >
          Copy Parent Menus
        </v-btn>
      </v-col>
      <!-- View Title -->
      <v-col >
        <ViewTitle title="Menus" />
      </v-col>
      <v-col
      class="d-flex justify-end mb-0 pb-0 component"
      md="auto"
      >
        <SearchTextAdmin @input="setSearchText" 
        @output="setSearchText"/>
      </v-col>
    </v-row>
    <v-data-table
      fixed
      small
      :items="menus"
      :headers="fields"
      dense
      item-class="qmkey-item-row"
      :search="search"
    >
      <template v-slot:[`item.name`]="{ item }">
        <!-- <v-btn
          @click.stop="editMenuForm(item.id)"
          text
          small
          class="qmkey-add-button-menu"
          :class="!item.parent ? 'menu_root font-weight-bold' : ''"
        >
          {{ menuTitle(item) }}
        </v-btn> -->
        {{ menuTitle(item) }}
      </template>
      <template v-slot:[`item.enabled`]="{ item }">
        <b v-if="item.enabled" class="text-success">✔</b>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click.stop="editMenuForm(item)"
          :disabled="!isAdmin"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click="addMenuForm(item.id)"
          :disabled="!isAdmin"
        >
          mdi-plus
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="deleteMenuForm(item)"
          :disabled="!isAdmin || !can_delete_menu(item.id)"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
    <!-- Add /edit /delete dialog-->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      validate
      @close-dialog="toggle_dialog"
      @submit="submit_action"
    >
    </modal-dialog-form>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import ViewTitle from '@/components/ViewTitle'
import Menu from '@/api/QMenuItem'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import SearchTextAdmin from '@/components/header/SearchTextAdmin'
import Roles from '@/api/Roles'

export default {
  name: 'MenusView',
  components: {
    ViewTitle,
    SearchTextAdmin,
    ModalDialogForm
  },

  data() {
    return {
      fields: [
        { value: 'name', text: 'Name' },
        { value: 'order', text: 'Order' },
        { value: 'url', text: 'URL' },
        { value: 'enabled', text: 'Enabled' },
        { value: 'actions', text: '', sortable: false },
      ],
      loading: false,
      modalSubTitle: '',
      alert: false,
      valid: false,
      search:'',

      modal_title: '',
      showModalDialog: false,
      fields_to_collect: [],
      submit_button_caption: 'Save', // Harcoded text
      submit_action: function () {},
      allRoles: [],
    }
  },

  computed: {
    ...mapState(['isLoading']),
    ...mapState('QMenu', ['currentMenu', 'error', 'menus']),
    ...mapGetters(['isAdmin', 'sitePath', 'centro_id']),
  },

  mounted: function() {
    /* this.SET_CURRENT_SITE(this.sitePath) */ // TODO: Remove this line?
    this.GET_MENUS();
    this.getRoles();
  },

  methods: {
    ...mapActions('QMenu', [
      'ADD_MENU',
      'DELETE_MENU',
      'GET_MENU',
      'GET_MENUS',
      'UPDATE_MENU',
      'COPY_FROM_PARENT',
    ]),

    ...mapMutations('QMenu', ['SET_CURRENT_MENU']),

    ...mapMutations(['SET_CURRENT_SITE', 'SHOW_ALERT']),

    get_fields(){
      let value_name=null
      let value_order=null
      let value_parent=null
      let value_url=null
      let value_enabled='true'
      let value_allowed_roles = null;
      let value_blocked_roles = null;
      if(this.currentMenu){
        value_name=this.currentMenu.name
        value_order=this.currentMenu.order
        value_parent=this.currentMenu.parent
        value_url=this.currentMenu.url
        value_enabled=this.currentMenu.enabled.toString()
        value_allowed_roles = this.currentMenu.allowed_roles;
        value_blocked_roles = this.currentMenu.blocked_roles;
      }
      return [
        [
          {
            id: 'name',
            label: 'Menu name',
            required: true,
            value: value_name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Menu Name',
          },
          
          {
            id: 'parent',
            label: 'Menu parent',
            required: false,
            value: value_parent,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Select Parent Menu',
            items: this.select_menus()
          },
        ],
        [
          {
            id: 'url',
            label: 'Menu url',
            required: false,
            value: value_url,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Menu URL',
          },
          {
            id: 'order',
            label: 'Menu order',
            required: true,
            value: value_order,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'NumericInput',
            placeholder: 'Enter Menu Order',
            min: 1
          },
        ],
        [
          {
            id: 'enabled',
            label: 'Is Enabled',
            required: true,
            value: value_enabled,
            readonly: this.menu_has_childs(this.currentMenu.id),
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [["true","True"],["false","False"]]
          },
        ],
        [
          {
            id: 'allowed_roles',
            label: 'Allowed roles',
            required: false,
            value: value_allowed_roles,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Choose allowed roles',
            items: this.allRoles.map((val) => [val.value, val.text]),
            multiple: true,
            help_text: "Select roles that can view the menu. Only selected roles can view the menu item."
          },
          {
            id: 'blocked_roles',
            label: 'Blocked roles',
            required: false,
            value: value_blocked_roles,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Choose blocked roles',
            items: this.allRoles.map((val) => [val.value, val.text]),
            multiple: true,
            help_text: "Select roles that can not view the menu. Selected roles can not view the menu item."
          },
        ],
      ] 
    },

    // Helper to display Menu name
    menuTitle(data) {
      return '- - '.repeat(data.indent) + data.name
    },

    // Forms
    addMenuForm(parent_id) {
      let currentMenu = {enabled:true}
      this.modal_title = 'Add new menu'
      if (parent_id) {
        currentMenu.parent = parent_id
        this.modal_title = 'Add new submenu'
      }
      this.SET_CURRENT_MENU(currentMenu)
      this.fields_to_collect = this.get_fields()
      this.showModalDialog = true
      this.submit_action = this.addMenu
      this.submit_button_caption = 'Save'
    },

    addMenu(formdata) {
      Menu.post(this.centro_id, formdata)
        .then(() => {
          this.GET_MENUS()
          this.showModalDialog=false
          this.currentSite={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    editMenuForm(item) {
      this.SET_CURRENT_MENU(item)
      this.modal_title = `Edit menu #${item.id}`
      this.fields_to_collect = this.get_fields()
      this.showModalDialog = true
      this.submit_action = this.updateMenu
      this.submit_button_caption = 'Save'
    },

    updateMenu(formdata){
      if(!formdata.get("url"))formdata.append('url','')
      if(!formdata.get("parent"))formdata.append('parent','')
      Menu.put(this.centro_id, this.currentMenu.id, formdata)
        .then(() => {
          this.GET_MENUS()
          this.showModalDialog=false
          this.SET_CURRENT_MENU({})
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    deleteMenuForm(item) {
      this.SET_CURRENT_MENU(item)
      this.modal_title = `Delete Menu #${item.id} ${item.name}`
      this.fields_to_collect = []
      this.showModalDialog = true
      this.submit_action = this.deleteMenu
      this.submit_button_caption = 'Delete'
    },

    deleteMenu(){
      Menu.delete(this.centro_id, this.currentMenu.id)
        .then(() => {
          this.GET_MENUS()
          this.showModalDialog=false
          this.SET_CURRENT_MENU({})
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    get_children_id(actual_menu){
      if(actual_menu){
        let children = [actual_menu.id]
        if(actual_menu.items){
          for(let child of actual_menu.items){
            children=children.concat(this.get_children_id(child))
          }
        }
        return children
      }else{
        return []
      }
    },
    select_menus(){
      let not_valid=this.get_children_id(this.currentMenu)
      return this.menus.filter((val) => !not_valid.includes(val.id)).map((val) => [val.id,val.name])
    },
    menu_has_childs(menu_id) {
      let menu = { items: [] }
      if (menu_id) {
        menu = this.menus.find(o => o.id === menu_id)
      }
      return !menu.items || menu.items.length > 0
    },
    can_delete_menu(menu_id) {
      let menu = { items: [] }
      if (menu_id) {
        menu = this.menus.find(o => o.id === menu_id)
      }
      if (!menu.items || menu.items.length == 0) {
        return true
      }
      return false
    },
    setSearchText(search_text) {
      this.search=search_text
    },
    toggle_dialog() {
      this.showModalDialog = false
      this.modal_title = ''
      this.fields_to_collect = []
      ;(this.submit_action = function () {}), (this.submit_button_caption = '')
      // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
    },
    getRoles() {
      Roles.get(this.sitePath)
        .then(response => {
          this.allRoles = []
          for (var role of response.results) {
            this.allRoles.push({ value: role.id, text: role.name })
          }
          this.checkInheritRoles()
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkInheritRoles() {
      Roles.listInheritance(this.sitePath)
        .then((response) => {
          let inheritRoles = response.map(v => ({text: v.name, value: v.id}));
          for(const i of inheritRoles){
            if (this.allRoles.some(v => v.value == i.value)) {
              this.allRoles.find(v => v.value == i.value).text = ' - '+i.text
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
    },
    async copyParentMenus() {
      try {
        await this.COPY_FROM_PARENT();
      } catch (error) {
        this.render_form_errors(error);
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/sass/menus.scss';
</style>
